var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9206 18.3525C94.6563 18.3525 96.0634 19.7596 96.0634 21.4954V89.6689C96.0634 95.8618 90.9502 100.858 84.7753 100.858H28.4749C26.7391 100.858 25.332 99.4511 25.332 97.7153C25.332 95.9796 26.7391 94.5725 28.4749 94.5725H84.7753C87.5513 94.5725 89.7777 92.3182 89.7777 89.6689V21.4954C89.7777 19.7596 91.1848 18.3525 92.9206 18.3525Z",
    fill: "#D2E5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8038 96.8318C20.6865 96.8318 17.2852 93.4717 17.2852 89.4043V55.0081V18.0476C17.2852 13.9802 20.6865 10.6201 24.8038 10.6201H84.3266C88.4439 10.6201 91.8452 13.9802 91.8452 18.0476V89.4043C91.8452 93.4717 88.4439 96.8318 84.3266 96.8318H24.8038Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.804 12.0336C21.4514 12.0336 18.6997 14.7767 18.6997 18.0468V89.4035C18.6997 92.6737 21.4514 95.4167 24.804 95.4167H84.3268C87.6794 95.4167 90.4312 92.6737 90.4312 89.4035V18.0468C90.4312 14.7767 87.6794 12.0336 84.3268 12.0336H24.804ZM15.8711 18.0468C15.8711 13.1821 19.9219 9.20508 24.804 9.20508H84.3268C89.2089 9.20508 93.2597 13.1821 93.2597 18.0468V89.4035C93.2597 94.2683 89.2089 98.2453 84.3268 98.2453H24.804C19.9219 98.2453 15.8711 94.2683 15.8711 89.4035V18.0468Z",
    fill: "#3694E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4286 61.5714C31.4286 60.7036 32.1321 60 33 60H78.1158C78.9837 60 79.6873 60.7036 79.6873 61.5714C79.6873 62.4393 78.9837 63.1429 78.1158 63.1429H33C32.1321 63.1429 31.4286 62.4393 31.4286 61.5714Z",
    fill: "#DEE9F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4286 53.5714C31.4286 52.7036 32.1321 52 33 52H78.1158C78.9837 52 79.6873 52.7036 79.6873 53.5714C79.6873 54.4393 78.9837 55.1429 78.1158 55.1429H33C32.1321 55.1429 31.4286 54.4393 31.4286 53.5714Z",
    fill: "#DEE9F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2959 45.5714C31.2959 44.7036 31.9995 44 32.8673 44L78.1154 44.0001C78.9833 44.0001 79.6868 44.7037 79.6868 45.5716C79.6868 46.4394 78.9833 47.143 78.1154 47.143L32.8673 47.1429C31.9995 47.1429 31.2959 46.4393 31.2959 45.5714Z",
    fill: "#DEE9F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 26.5714C51 25.7036 51.7036 25 52.5714 25L64.8195 25.0001C65.6874 25.0001 66.3909 25.7037 66.3909 26.5716C66.3909 27.4394 65.6874 28.143 64.8195 28.143L52.5714 28.1429C51.7036 28.1429 51 27.4393 51 26.5714Z",
    fill: "#DEE9F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 33.5714C51 32.7036 51.7036 32 52.5714 32L64.8195 32.0001C65.6874 32.0001 66.3909 32.7037 66.3909 33.5716C66.3909 34.4394 65.6874 35.143 64.8195 35.143L52.5714 35.1429C51.7036 35.1429 51 34.4393 51 33.5714Z",
    fill: "#DEE9F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4209 70.5714C30.4209 69.7036 31.1245 69 31.9923 69H78.406C79.2738 69 79.9774 69.7036 79.9774 70.5714V81.0763C79.9774 81.9442 79.2738 82.6477 78.406 82.6477H31.9923C31.1245 82.6477 30.4209 81.9442 30.4209 81.0763V70.5714ZM33.5638 72.1429V79.5049H76.8345V72.1429H33.5638Z",
    fill: "#DEE9F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4865 35H73.5135C71.6216 35 70 33.3784 70 31.4865V28.5135C70 26.6216 71.6216 25 73.5135 25H76.4865C78.3784 25 80 26.6216 80 28.5135V31.4865C80 33.3784 78.6487 35 76.4865 35Z",
    fill: "#2DD68A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5974 22.9551H31.6123V26.9401H35.5974V22.9551Z",
    fill: "#DEE9F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9109 22.9551H36.9258V26.9401H40.9109V22.9551Z",
    fill: "#DEE9F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5974 28.2686H31.6123V32.2536H35.5974V28.2686Z",
    fill: "#DEE9F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9109 28.2686H36.9258V32.2536H40.9109V28.2686Z",
    fill: "#DEE9F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2243 28.2686H42.2393V32.2536H46.2243V28.2686Z",
    fill: "#DEE9F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5974 33.582H31.6123V37.5671H35.5974V33.582Z",
    fill: "#DEE9F2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9109 33.582H36.9258V37.5671H40.9109V33.582Z",
    fill: "#DEE9F2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2243 33.582H42.2393V37.5671H46.2243V33.582Z",
    fill: "#DEE9F2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2243 22.9551H42.2393V26.9401H46.2243V22.9551Z",
    fill: "#DEE9F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsf);
export default __webpack_public_path__ + "static/media/csf.226b54e1bb57a1faedbf9da466f03ef7.svg";
export { ForwardRef as ReactComponent };